/** Isolated rewarded-ad constants. Base economy/balancing values stay untouched. */

export const BUILD_DISCOUNT_PERCENT = 25;
export const LAND_DISCOUNT_PERCENT = 25;
export const AUTO_COLLECT_DURATION_MS = 10 * 60 * 1000;
export const REWARDED_GLOBAL_COOLDOWN_MS = 3 * 60 * 1000;
export const FIRST_SESSION_DELAY_MS = 3 * 60 * 1000;
export const REWARDED_DISCOUNT_FACTOR = 0.75;

export const REWARDED_STATE_STORAGE_KEY = 'park_v1_rewarded_v1';
export const REWARDED_STATE_VERSION = 1;
export const LOCAL_ADS_QUERY_PARAM = 'parkAds';
export const LOCAL_ADS_STORAGE_KEY = 'park_v1_ads_dev';

export function discountedIntegerCost(baseCost: number): number {
  return Math.max(1, Math.floor(baseCost * REWARDED_DISCOUNT_FACTOR));
}
